import { formatDate } from '@angular/common';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ApiservicesService } from '../../apiservices.service';
import { EncryptdecryptService } from '../../services/encryptdecrypt.service';

@Component({
  selector: 'app-sidebar-profile',
  templateUrl: './sidebar-profile.component.html',
  styleUrls: ['./sidebar-profile.component.css']
})
export class SidebarProfileComponent implements OnInit {

  LoaderStatus: boolean = false;

  RequestTokenResult: any;

  //Date Variable
  DateOption: any;

  //UI View Variables
  NameView: any = "";
  IDNoView: any = "";
  LastLoginView: any;

  //UI Sidebar Variables
  StaffID: any = "";
  StaffIDNo: any = "";
  StaffName: any = "";
  StaffStatus: any = "";
  StaffFirmDetails: any[] = [];
  FirmTaxRefNum: any = "";
  

  //UI Input
  FirmInput: any = "";

  //Session Variables
  StaffRoles: any[] = [];

  //Child to parent variables
  @Output() StaffRolesEvent = new EventEmitter<any>();

  constructor(private apiServices: ApiservicesService, public router: Router, private encryptDecryptService: EncryptdecryptService) { }

  ngOnInit(): void {
    this.GetProfile();
    this.GetFirm();
    this.GetAgentDetails(this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDNo') || ''), this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || ''));
    this.FirmInput = this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '');
    this.GetFirmUser(this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDNo') || ''), this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || ''),false);
  }

  async GetProfile() {
    const result = await this.apiServices.RequestToken();
    this.NameView = result.body.FullName;
    this.IDNoView = result.body.IdNo;
  }

  async GetFirm() {
    const result = await this.apiServices.GetFirmList(this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDNo') || ''));
    sessionStorage.removeItem('StaffID');
    sessionStorage.setItem('StaffID', this.encryptDecryptService.encrypt(result.staffID));
    this.StaffID = result.staffID;
    this.StaffIDNo = result.staffIDNo;
    this.StaffName = result.staffName;
    this.StaffStatus = result.status;
    this.StaffFirmDetails = result.taFirm;
    this.StaffFirmDetails.forEach((currentValue: any, index: any) => {
      if (this.StaffFirmDetails[index].firmID == this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || ''))
        this.FirmTaxRefNum = this.StaffFirmDetails[index].taxReference_No;
    });
  }

  async GetAgentDetails(IDNo:any, FirmID:any ) {
    sessionStorage.removeItem('TaxAgentID');
    let Params = {
      "IDNo": IDNo,
      "FirmID": FirmID
    }
    const result = await this.apiServices.GetAgentDetailByIDNo(Params);
    if (result.hasError)
      sessionStorage.removeItem('TaxAgentID');
    else
      sessionStorage.setItem('TaxAgentID', this.encryptDecryptService.encrypt(String(result.taxAgentId)));
  }

  async ChangeFirm(FirmID: any) {
    this.LoaderStatus = true;
    sessionStorage.removeItem('FirmID');
    sessionStorage.setItem('FirmID', this.encryptDecryptService.encrypt(FirmID));
    this.ChangeRolesView(this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || ''));
    this.StaffFirmDetails.forEach((currentValue: any, index: any) => {
      if (this.StaffFirmDetails[index].FirmID == this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || ''))
        this.FirmTaxRefNum = this.StaffFirmDetails[index].TaxReference_No;
    });
    this.redirectTo(this.router.url);
    this.LoaderStatus = false;
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }
  ChangeRolesView(value: any) {
    this.StaffRolesEvent.emit(value);
  }
  async GetFirmUser(StaffIDNo: any, FirmID: any, Login: boolean) {
    this.DateOption = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const result = await this.apiServices.GetFirmUserByICNO(StaffIDNo, FirmID, Login);
    this.LastLoginView = formatDate(result[0].lastLogin, 'dd-MMM-yyyy h:mm:ss a', "en-US");
  }
}
